import store from '../../store';
import Helper from '../../helpers/helper';

import { setAppLoadingState } from '../../actions/app/app';
import { mainviewActions } from '../../helpers/constants';
import { hideModal, showModal } from '../modal/modal';

export const geolocateUser = () => {
  return dispatch => {

    if ('geolocation' in window.navigator) {
      dispatch(setAppLoadingState(true));

      navigator.geolocation.getCurrentPosition(
        posSuccess => {
          dispatch(geolocated({
            lat: posSuccess.coords.latitude,
            lon: posSuccess.coords.longitude,
            isSuccessful: true
          }));

          dispatch(setAppLoadingState(false));
        },
        () => {
          dispatch(geolocated({ isSuccessful: false }));
          dispatch(setAppLoadingState(false));
          
          Helper.setNotification('danger', 'Error', 'Unable to geolocate you. Please try again later.');
      }, { enableHighAccuracy: true });
    }

  }
}

export const addKoalaSighting = sightingData => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    const userInfo = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    Helper.makeRequest('data/sightings', 'POST', userInfo?.token, sightingData, null, 'automatic')
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {

      dispatch(hideModal());
      dispatch({
        type: mainviewActions.ADD_SIGHTING_SUCCESS,
        id: json.id
      });
      
      const mainview = store.getState().mainview;
      
      // Move map to updated location
      mainview.latitude = json.latitude;
      mainview.longitude = json.longitude;

      Helper.setNotification('success', 'Success', 'Koala sighting created successfully.', true);
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error creating sighting', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

/// Get sightings by user (using JWT token)
export const getKoalaSightingsByUser = (page = 1, onlyVerified = null, status = null, prev = null, next = null) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    let searchTerms = '';

    if (onlyVerified !== null) searchTerms += `&verified=${ onlyVerified }`;
    if (status !== null) searchTerms += `&status=${ status }`;

    const userToken = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    let url =
      prev || next ? 
        (prev ? prev : next) :
        `data/sightings?page=${ page + searchTerms }`;

    Helper.makeRequest(url, 'GET', userToken?.token, null, null, null, (prev || next ? true : false))
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      dispatch({
        type: mainviewActions.GET_KOALA_SIGHTINGS_BY_USER,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors, true);

      dispatch(hideModal());
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

/// Get all sightings (Admin only)
export const getAllKoalaSightings = (page = 1, onlyVerified = true, status = null, prev = null, next = null) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    let searchTerms = '';

    if (onlyVerified !== null) searchTerms += `&verified=${ onlyVerified }`;
    if (status !== null) searchTerms += `&status=${ status }`;

    const userToken = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    let url =
      prev || next ? 
        (prev ? prev : next) :
        `data/sightings/all?page=${ page + searchTerms }`;
    
    Helper.makeRequest(url, 'GET', userToken?.token, null, null, null, (prev || next ? true : false))
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      dispatch({
        type: mainviewActions.GET_ALL_KOALA_SIGHTINGS,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors, true);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const showEditKoalaSighting = sighting => {
  return dispatch => {

    dispatch({
      type: mainviewActions.EDIT_KOALA_SIGHTING,
      payload: sighting
    });

    dispatch(showModal('EditSighting'));

  }
}

export const updateKoalaSighting = (formData, sightingId) => {
  return dispatch => {
  
    dispatch(setAppLoadingState(true));

    const userToken = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    Helper.makeRequest(`data/sightings/${ sightingId }`, 'PUT', userToken?.token, formData, null, 'automatic')
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      
      const mainview = store.getState().mainview;
      
      dispatch(hideModal());
      dispatch({ type: mainviewActions.EDIT_KOALA_SIGHTING_SUCCESS });

      // Move map to updated location
      mainview.latitude = json.latitude;
      mainview.longitude = json.longitude;
 
      Helper.setNotification('success', 'Success', 'Koala sighting updated successfully.', true);
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors, true);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const getUserAccounts = (page = 1, searchQuery = null, isAdmin = null, isAKF = null, isLicensed = null, prev = null, next = null) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    let searchTerms = '';

    if (searchQuery !== null && searchQuery !== '') searchTerms += `&search=${ searchQuery }`;
    if (isAdmin !== null && isAdmin !== 'null') searchTerms += `&is_admin=${ isAdmin }`;
    if (isAKF !== null && isAKF !== 'null') searchTerms += `&is_akfstaff=${ isAKF }`;
    if (isLicensed !== null && isLicensed !== 'null') searchTerms += `&is_licenseduser=${ isLicensed }`;
    
    const userToken = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    let url =
      prev || next ? 
        (prev ? prev : next) :
        `data/users?page=${ page + searchTerms }`;

    Helper.makeRequest(url, 'GET', userToken?.token, null, null, null, (prev || next ? true : false))
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      dispatch({
        type: mainviewActions.GET_USER_ACCOUNTS,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors, true);
    })
    .finally(() => dispatch(setAppLoadingState(false)));
    
  }
}

export const showEditUser = account => {
  return dispatch => {

    dispatch({
      type: mainviewActions.EDIT_USER_ACCOUNT,
      payload: account
    });

    dispatch(showModal('EditUser'));

  }
}

export const getFederalBoundaryInfo = (lng, lat) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    Helper.makeRequest(`data/federals/${ lng },${ lat }`, 'GET')
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      dispatch({
        type: mainviewActions.GET_FEDERAL_BOUNDARY_DATA,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      dispatch({
        type: mainviewActions.GET_FEDERAL_BOUNDARY_DATA,
        payload: {
          notFoundText: 'Federal information not found.'
        }
      });
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const getStateBoundaryInfo = (lng, lat) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    Helper.makeRequest(`data/states/${ lng },${ lat }`, 'GET')
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      dispatch({
        type: mainviewActions.GET_STATE_BOUNDARY_DATA,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      dispatch({
        type: mainviewActions.GET_STATE_BOUNDARY_DATA,
        payload: {
          notFoundText: 'State information not found.'
        }
      });
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const getLGABoundaryInfo = (lng, lat) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    Helper.makeRequest(`data/lgas/${ lng },${ lat }`, 'GET')
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.json();
    })
    .then(json => {
      dispatch({
        type: mainviewActions.GET_LGA_BOUNDARY_DATA,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      dispatch({
        type: mainviewActions.GET_LGA_BOUNDARY_DATA,
        payload: {
          notFoundText: 'LGA information not found.'
        }
      });
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

const geolocated = geolocateObj => ({
  type: geolocateObj.isSuccessful === true ?
      mainviewActions.GEOLOCATE_USER_SUCCESS :
      mainviewActions.GEOLOCATE_USER_ERROR,
    payload: geolocateObj
})

export const setMapLayerType = layerString => ({
  type: mainviewActions.SET_MAP_LAYER_TYPE,
  payload: layerString
})

export const storeMap = map => ({
  type: mainviewActions.STORE_MAP,
  payload: map
})

export const toggleSightingLayer = showLayer => {
  return dispatch => {

    dispatch({
      type: showLayer ?
        mainviewActions.SHOW_KOALA_GEOJSON :
        mainviewActions.HIDE_KOALA_GEOJSON,
      payload: showLayer
    });

    if (!showLayer) dispatch(toggleKoalaPopup(false));

  }
}

export const toggleFederalLayer = showLayer => {
  return dispatch => {

    dispatch({
      type: showLayer ? 
        mainviewActions.SHOW_FEDERAL_GEOJSON :
        mainviewActions.HIDE_FEDERAL_GEOJSON,
      payload: showLayer
    });

  }
}

export const toggleStateLayer = showLayer => {
  return dispatch => {

    dispatch({
      type: showLayer ?
        mainviewActions.SHOW_STATE_GEOJSON :
        mainviewActions.HIDE_STATE_GEOJSON,
      payload: showLayer
    });

  }
}

export const toggleLGALayer = showLayer => {
  return dispatch => {

    dispatch({
      type: showLayer ?
        mainviewActions.SHOW_LGA_GEOJSON :
        mainviewActions.HIDE_LGA_GEOJSON,
      payload: showLayer
    });

  }
}

export const togglePropertyLayer = showLayer => ({
  type: showLayer ? 
    mainviewActions.SHOW_PROPERTY_LAYER :
    mainviewActions.HIDE_PROPERTY_LAYER,
  payload: showLayer
})

export const toggleHabitatLayer = (layer, toShow) => {
  return dispatch => {

    if (layer === 'NVIS') dispatch({ type: mainviewActions.SHOW_NVIS_LAYER, payload: toShow });
    else if (layer === 'KHA') dispatch({ type: mainviewActions.SHOW_KHA_LAYER, payload: toShow });
    else if (layer === 'PreClear') dispatch({ type: mainviewActions.SHOW_PRECLEARING_LAYER, payload: toShow });
    else return false;
    
  }
}

export const searchAddressSelected = address => ({
  type: mainviewActions.SEARCH_ADDRESS_SELECTED,
  payload: address
})

export const koalaItemClick = (show, data) => {

  return dispatch => dispatch(toggleKoalaPopup(show, data));

}
export const koalaPopupClose = () => {

  return dispatch => dispatch(toggleKoalaPopup(false));

}
const toggleKoalaPopup = (show, data) => ({
  type: show ?
    mainviewActions.SHOW_KOALA_POPUP :
    mainviewActions.HIDE_KOALA_POPUP,
  payload: {
    show: show,
    data: data
  }
});

export const downloadSightings = userId => {
  return dispatch => {

    const userInfo = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    const reqUrl = userId ?
      `data/users/${ userId }/sightings` : // User downloading their own sightings
      'data/sightings/download'; // Admin downloading all

    Helper.makeRequest(reqUrl, 'GET', userInfo?.token)
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);

      return Response.blob();
    })
    .then(blob => {
      Helper.setNotification('success', 'Success', 'Sightings have been downloaded successfully.');

      const link = document.createElement('a');

      link.href = window.URL.createObjectURL(blob, {
        type: "text/plain"
      });
      
      link.setAttribute('download', `${ userId ? 'my' : 'all' }_sightings.csv`);
      document.body.appendChild(link);

      link.click();
      link.remove();
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      Helper.setNotification('danger', 'Error', 'There was an error downloading the sightings. Please try again later.');
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const boundaryItemClick = (show, lnglat) => {

  return dispatch => dispatch(toggleBoundaryPopup(show, lnglat));

}
export const boundaryPopupClose = () => {

  return dispatch => dispatch(toggleBoundaryPopup(false));

}
const toggleBoundaryPopup = (show, lnglat) => ({
  type: show ?
    mainviewActions.SHOW_BOUNDARY_POPUP :
    mainviewActions.HIDE_BOUNDARY_POPUP,
  payload: {
    show: show,
    coords: lnglat
  }
});

export const hideSearchMarker = () => ({
  type: mainviewActions.HIDE_SEARCH_MARKER
});